// SoyCandleLab live catalogue — generated from soycandlelab.com.au products.json 2026-07-29
const PRODUCTS = [
  {
    "title": "Lotus",
    "handle": "lotus",
    "cat": "candles",
    "price": 40.0,
    "priceMax": 40.0,
    "variants": 1,
    "desc": "A delicate and floral fragrance, blending aquatic lotus, oriental flowers and sweetness of vanilla.",
    "notes": {
      "top": "Geranium, Jasmine",
      "middle": "Lotus Flower, White Musk",
      "base": "Patchuli, Vanilla ----------------------------------------------------------------------"
    },
    "img": "assets/img/lotus-garden-ledge.jpg",
    "gallery": ["assets/img/lotus-garden-ledge.jpg","assets/img/lotus-timber-table.jpg","assets/img/lotus-plant-nook.jpg","assets/img/lotus-ivory-studio.jpg"],
    "url": "https://soycandlelab.com.au/products/lotus"
  },
  {
    "title": "Aroma Therapy Trio",
    "handle": "aroma-therapy-trio",
    "cat": "candles",
    "price": 75.0,
    "priceMax": 75.0,
    "variants": 1,
    "desc": "Three candles in a box, made using premium essential oils for your aromatherapy needs. Mindfulness: Eucalyptus, Lemon Myrtle, Lemongrass and Peppermint, made to refresh your mind. Energise: Bergamot, Orange, Lemongrass and Lemon, made to energise your senses. Spiritually: Lavender, Frankincense, Lemongrass and Peppermint, made to soothe your spirit.",
    "notes": {},
    "img": "assets/img/aroma-therapy-trio-garden-ledge.jpg",
    "url": "https://soycandlelab.com.au/products/aroma-therapy-trio",
    "gallery": [
      "assets/img/aroma-therapy-trio-garden-ledge.jpg",
      "assets/img/aroma-therapy-trio-timber-table.jpg",
      "assets/img/aroma-therapy-trio-plant-nook.jpg",
      "assets/img/aroma-therapy-trio-ivory-studio.jpg"
    ]
  },
  {
    "title": "Petal Candle",
    "handle": "petal-candle",
    "cat": "candles",
    "price": 55.0,
    "priceMax": 55.0,
    "variants": 30,
    "desc": "Our large 400g candle, available in every scent. It fills bigger rooms and open floor plans with a slow, steady glow for approx. 60+ hours.",
    "notes": {},
    "img": "assets/img/petal-ivory-studio.jpg",
    "gallery": [
      "assets/img/petal-ivory-studio.jpg",
      "assets/img/petal-timber-table.jpg",
      "assets/img/petal-garden-ledge.jpg",
      "assets/img/petal-plant-nook.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/petal-candle",
    "variantGalleries": {
      "love": [
        "assets/img/love-garden-ledge.jpg",
        "assets/img/love-timber-table.jpg",
        "assets/img/love-plant-nook.jpg",
        "assets/img/love-ivory-studio.jpg"
      ],
      "strawberrieschampagne": [
        "assets/img/strawberry-champagne-garden-ledge.jpg",
        "assets/img/strawberry-champagne-timber-table.jpg",
        "assets/img/strawberry-champagne-plant-nook.jpg",
        "assets/img/strawberry-champagne-ivory-studio.jpg"
      ]
    }
  },
  {
    "title": "Beeswax Pillar Candles",
    "handle": "beeswax-pillar-candles",
    "cat": "candles",
    "price": 20.0,
    "priceMax": 35.0,
    "variants": 9,
    "desc": "Our Beeswax pillar candles are natural and eco-friendly, made from pure, organic Australian beeswax. Nine styles, in this order in the photos: Large lotus ball, Large swirl ball, Large knitted ball and Large tower ($35 each), then Medium geometric pear, Medium floral and Medium honey bubble ($25 each), then the Small peony flower and Small rose flower ($20 each).",
    "notes": {},
    "img": "assets/img/beeswax-lotus-ball-garden-ledge.jpg",
    "url": "https://soycandlelab.com.au/products/beeswax-pillar-candles",
    "gallery": [
      "assets/img/beeswax-lotus-ball-garden-ledge.jpg",
      "assets/img/beeswax-swirl-ball-garden-ledge.jpg",
      "assets/img/beeswax-knitted-ball-garden-ledge.jpg",
      "assets/img/beeswax-pillar-garden-ledge.jpg",
      "assets/img/beeswax-geometric-pear-garden-ledge.jpg",
      "assets/img/beeswax-floral-garden-ledge.jpg",
      "assets/img/beeswax-honey-bubble-garden-ledge.jpg",
      "assets/img/peony-pillar-garden-ledge.jpg",
      "assets/img/rose-pillar-garden-ledge.jpg"
    ],
    "variantGalleries": {
      "largelotusball": [
        "assets/img/beeswax-lotus-ball-garden-ledge.jpg",
        "assets/img/beeswax-lotus-ball-timber-table.jpg",
        "assets/img/beeswax-lotus-ball-plant-nook.jpg",
        "assets/img/beeswax-lotus-ball-ivory-studio.jpg"
      ],
      "largeswirlball": [
        "assets/img/beeswax-swirl-ball-garden-ledge.jpg",
        "assets/img/beeswax-swirl-ball-timber-table.jpg",
        "assets/img/beeswax-swirl-ball-plant-nook.jpg",
        "assets/img/beeswax-swirl-ball-ivory-studio.jpg"
      ],
      "largeknittedball": [
        "assets/img/beeswax-knitted-ball-garden-ledge.jpg",
        "assets/img/beeswax-knitted-ball-timber-table.jpg",
        "assets/img/beeswax-knitted-ball-plant-nook.jpg",
        "assets/img/beeswax-knitted-ball-ivory-studio.jpg"
      ],
      "mediumgeometricpear": [
        "assets/img/beeswax-geometric-pear-garden-ledge.jpg",
        "assets/img/beeswax-geometric-pear-timber-table.jpg",
        "assets/img/beeswax-geometric-pear-plant-nook.jpg",
        "assets/img/beeswax-geometric-pear-ivory-studio.jpg"
      ],
      "mediumfloral": [
        "assets/img/beeswax-floral-garden-ledge.jpg",
        "assets/img/beeswax-floral-timber-table.jpg",
        "assets/img/beeswax-floral-plant-nook.jpg",
        "assets/img/beeswax-floral-ivory-studio.jpg"
      ],
      "mediumhoneybubble": [
        "assets/img/beeswax-honey-bubble-garden-ledge.jpg",
        "assets/img/beeswax-honey-bubble-timber-table.jpg",
        "assets/img/beeswax-honey-bubble-plant-nook.jpg",
        "assets/img/beeswax-honey-bubble-ivory-studio.jpg"
      ],
      "smallpeonyflower": [
        "assets/img/peony-pillar-garden-ledge.jpg",
        "assets/img/peony-pillar-timber-table.jpg",
        "assets/img/peony-pillar-plant-nook.jpg",
        "assets/img/peony-pillar-ivory-studio.jpg"
      ],
      "smallroseflower": [
        "assets/img/rose-pillar-garden-ledge.jpg",
        "assets/img/rose-pillar-timber-table.jpg",
        "assets/img/rose-pillar-plant-nook.jpg",
        "assets/img/rose-pillar-ivory-studio.jpg"
      ],
      "largetower": [
        "assets/img/beeswax-pillar-garden-ledge.jpg",
        "assets/img/beeswax-pillar-timber-table.jpg",
        "assets/img/beeswax-pillar-plant-nook.jpg",
        "assets/img/beeswax-pillar-ivory-studio.jpg"
      ]
    }
  },
  {
    "title": "Melbourne Botanical",
    "handle": "melbourne-botantical",
    "cat": "candles",
    "price": 40.0,
    "priceMax": 40.0,
    "variants": 1,
    "desc": "Inspired by Melbourne's lush gardens and native landscapes, Melbourne Botanical captures the beauty of Naarm's natural flora.",
    "notes": {
      "top": "Australian Bush, Bergamont, Lemon Myrtle",
      "middle": "Jasmine, Golden Honeysuckle, Eucalyptus",
      "base": "Rosewood, Soft Native Woods ----------------------------------------------------------------------"
    },
    "img": "assets/img/melbourne-garden-ledge.jpg",
    "gallery": [
      "assets/img/melbourne-garden-ledge.jpg",
      "assets/img/melbourne-timber-table.jpg",
      "assets/img/melbourne-plant-nook.jpg",
      "assets/img/melbourne-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/melbourne-botantical"
  },
  {
    "title": "Lemon Myrtle Eucalyptus",
    "handle": "lemon-myrtle-eucalyptus",
    "cat": "candles",
    "price": 40.0,
    "priceMax": 40.0,
    "variants": 1,
    "desc": "Refresh your senses with our herbaceous candle.",
    "notes": {
      "top": "Eucalyptus, Lemon, Pine Needles",
      "middle": "Lemon Myrtle, Sage",
      "base": "Sandalwood ----------------------------------------------------------------------"
    },
    "img": "assets/img/lemon-myrtle-garden-ledge.jpg",
    "gallery": [
      "assets/img/lemon-myrtle-garden-ledge.jpg",
      "assets/img/lemon-myrtle-timber-table.jpg",
      "assets/img/lemon-myrtle-plant-nook.jpg",
      "assets/img/lemon-myrtle-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/lemon-myrtle-eucalyptus"
  },
  {
    "title": "French Pear",
    "handle": "french-pear",
    "cat": "candles",
    "price": 40.0,
    "priceMax": 40.0,
    "variants": 1,
    "desc": "Delicate and rich fragrance that captures the essence of sun-ripened pears with an undertone of buttery and sweet aromas.",
    "notes": {
      "top": "Citrus, Cinnamon",
      "middle": "Pear, Cloves, Melon",
      "base": "Vanilla, Musk, Orchid ----------------------------------------------------------------------"
    },
    "img": "assets/img/french-pear-garden-ledge.jpg",
    "gallery": [
      "assets/img/french-pear-garden-ledge.jpg",
      "assets/img/french-pear-timber-table.jpg",
      "assets/img/french-pear-plant-nook.jpg",
      "assets/img/french-pear-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/french-pear"
  },
  {
    "title": "Christmas",
    "handle": "christmas",
    "cat": "candles",
    "price": 40.0,
    "priceMax": 40.0,
    "variants": 1,
    "desc": "Bring the warm fragrance of Christmas to your home with our special edition Christmas candle.",
    "notes": {
      "top": "Clove, Nutmeg, Fir Needle, Tangelo",
      "middle": "Cinnamon, Nectarines, Aniseed",
      "base": "Vanilla, Cedar Wood, Musk ----------------------------------------------------------------------"
    },
    "img": "assets/img/christmas-garden-ledge.jpg",
    "gallery": [
      "assets/img/christmas-garden-ledge.jpg",
      "assets/img/christmas-timber-table.jpg",
      "assets/img/christmas-plant-nook.jpg",
      "assets/img/christmas-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/christmas"
  },
  {
    "title": "Pumpkin Spice",
    "handle": "pumpkin-spice",
    "cat": "candles",
    "price": 40.0,
    "priceMax": 40.0,
    "variants": 1,
    "desc": "Warmth of pumpkin pie with rich spices",
    "notes": {
      "top": "Apple, Pear, butter",
      "middle": "Pumpkin, cinnamon, nutmeg, cloves",
      "base": "Vanilla, toffee ----------------------------------------------------------------------"
    },
    "img": "assets/img/pumpkin-spice-garden-ledge.jpg",
    "gallery": [
      "assets/img/pumpkin-spice-garden-ledge.jpg",
      "assets/img/pumpkin-spice-timber-table.jpg",
      "assets/img/pumpkin-spice-plant-nook.jpg",
      "assets/img/pumpkin-spice-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/pumpkin-spice"
  },
  {
    "title": "Amalfi Coast",
    "handle": "amalfi-coast",
    "cat": "candles",
    "price": 40.0,
    "priceMax": 40.0,
    "variants": 1,
    "desc": "Refreshing scent, inspired by the Italian coast of Amalfi.",
    "notes": {
      "top": "Lemon, Lime",
      "middle": "Amber, Wild Freesia",
      "base": "Patchouli, Sandalwood ----------------------------------------------------------------------"
    },
    "img": "assets/img/amalfi-coast-garden-ledge.jpg",
    "gallery": [
      "assets/img/amalfi-coast-garden-ledge.jpg",
      "assets/img/amalfi-coast-timber-table.jpg",
      "assets/img/amalfi-coast-plant-nook.jpg",
      "assets/img/amalfi-coast-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/amalfi-coast"
  },
  {
    "title": "Jasmine Gardenia",
    "handle": "jasmine-gardenia",
    "cat": "candles",
    "price": 40.0,
    "priceMax": 40.0,
    "variants": 1,
    "desc": "A beautifully floral fragrance.",
    "notes": {
      "top": "Jasmine, Gardenia",
      "middle": "Rose",
      "base": "Lily of the valley ----------------------------------------------------------------------"
    },
    "img": "assets/img/jasmine-gardenia-garden-ledge.jpg",
    "gallery": [
      "assets/img/jasmine-gardenia-garden-ledge.jpg",
      "assets/img/jasmine-gardenia-timber-table.jpg",
      "assets/img/jasmine-gardenia-plant-nook.jpg",
      "assets/img/jasmine-gardenia-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/jasmine-gardenia"
  },
  {
    "title": "Love",
    "handle": "romance",
    "cat": "candles",
    "price": 40.0,
    "priceMax": 40.0,
    "variants": 1,
    "desc": "Lovely floral aromas with a hint of jasmine and musk to set a romantic scene .",
    "notes": {
      "top": "Jasmine, Rosewood",
      "middle": "Amber, Lili of the valley",
      "base": "Musk, Vanilla ----------------------------------------------------------------------"
    },
    "img": "assets/img/love-garden-ledge.jpg",
    "gallery": [
      "assets/img/love-garden-ledge.jpg",
      "assets/img/love-timber-table.jpg",
      "assets/img/love-plant-nook.jpg",
      "assets/img/love-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/romance"
  },
  {
    "title": "Golden Honeysuckle",
    "handle": "golden-honeysuckel",
    "cat": "candles",
    "price": 40.0,
    "priceMax": 40.0,
    "variants": 1,
    "desc": "Exotic summer notes of warm florals and tropical fruits.",
    "notes": {
      "top": "Lemon, Papaya, Pineapple",
      "middle": "Mango, Melon, Hibiscus",
      "base": "Sandalwood, Coconut ----------------------------------------------------------------------"
    },
    "img": "assets/img/honeysuckle-garden-ledge.jpg",
    "gallery": [
      "assets/img/honeysuckle-garden-ledge.jpg",
      "assets/img/honeysuckle-timber-table.jpg",
      "assets/img/honeysuckle-plant-nook.jpg",
      "assets/img/honeysuckle-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/golden-honeysuckel"
  },
  {
    "title": "Coconut Margarita",
    "handle": "coconut-margarita",
    "cat": "candles",
    "price": 40.0,
    "priceMax": 40.0,
    "variants": 1,
    "desc": "Tropical scent of coconut, lime and a hint of creamy vanilla.",
    "notes": {
      "top": "Coconut Cream, Lime",
      "middle": "Coconut, Verbena, Lemon Zest",
      "base": "Vanilla, White Musk ----------------------------------------------------------------------"
    },
    "img": "assets/img/coconut-margarita-garden-ledge.jpg",
    "gallery": [
      "assets/img/coconut-margarita-garden-ledge.jpg",
      "assets/img/coconut-margarita-timber-table.jpg",
      "assets/img/coconut-margarita-plant-nook.jpg",
      "assets/img/coconut-margarita-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/coconut-margarita"
  },
  {
    "title": "Strawberry Champagne",
    "handle": "strawberries-champagne",
    "cat": "candles",
    "price": 40.0,
    "priceMax": 40.0,
    "variants": 1,
    "desc": "Romantic fragrance with a hint of strawberries, champagne and roses.",
    "notes": {
      "top": "Rasberries, Peach Nectar, Citrus",
      "middle": "Strawberries, Champagne, Roses",
      "base": "Musk, Jasmine ----------------------------------------------------------------------"
    },
    "img": "assets/img/strawberry-champagne-garden-ledge.jpg",
    "gallery": [
      "assets/img/strawberry-champagne-garden-ledge.jpg",
      "assets/img/strawberry-champagne-timber-table.jpg",
      "assets/img/strawberry-champagne-plant-nook.jpg",
      "assets/img/strawberry-champagne-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/strawberries-champagne"
  },
  {
    "title": "Ocean",
    "handle": "ocean",
    "cat": "candles",
    "price": 40.0,
    "priceMax": 40.0,
    "variants": 1,
    "desc": "Relaxing blend of refreshing coastal fragrances.",
    "notes": {
      "top": "Sea Salt, Citrus",
      "middle": "Apple, Violet",
      "base": "White Musk, Jasmine, Rosewood ----------------------------------------------------------------------"
    },
    "img": "assets/img/ocean-garden-ledge.jpg",
    "gallery": [
      "assets/img/ocean-garden-ledge.jpg",
      "assets/img/ocean-timber-table.jpg",
      "assets/img/ocean-plant-nook.jpg",
      "assets/img/ocean-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/ocean"
  },
  {
    "title": "Lemongrass",
    "handle": "lemongrass",
    "cat": "candles",
    "price": 40.0,
    "priceMax": 40.0,
    "variants": 1,
    "desc": "A vibrant aroma of lemongrass with a hint of lime and citrus.",
    "notes": {
      "top": "Lime zest, Mandarine",
      "middle": "Lemongrass",
      "base": "Amber, Lemon Verbena ----------------------------------------------------------------------"
    },
    "img": "assets/img/lemongrass-garden-ledge.jpg",
    "gallery": [
      "assets/img/lemongrass-garden-ledge.jpg",
      "assets/img/lemongrass-timber-table.jpg",
      "assets/img/lemongrass-plant-nook.jpg",
      "assets/img/lemongrass-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/lemongrass"
  },
  {
    "title": "Gin Spice",
    "handle": "gin-spice",
    "cat": "candles",
    "price": 40.0,
    "priceMax": 40.0,
    "variants": 1,
    "desc": "Gin scented candle reflecting hints of citrus lemon and botanicals.",
    "notes": {
      "top": "Lime, Mandarine, Mint",
      "middle": "Juniper Berries, Cedar",
      "base": "Amber, Lemon, Musk ----------------------------------------------------------------------"
    },
    "img": "assets/img/gin-spice-garden-ledge.jpg",
    "gallery": [
      "assets/img/gin-spice-garden-ledge.jpg",
      "assets/img/gin-spice-timber-table.jpg",
      "assets/img/gin-spice-plant-nook.jpg",
      "assets/img/gin-spice-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/gin-spice"
  },
  {
    "title": "Cinnamon",
    "handle": "cinnamon",
    "cat": "candles",
    "price": 40.0,
    "priceMax": 40.0,
    "variants": 1,
    "desc": "Rich notes of cinnamon and a medley of spices.",
    "notes": {
      "top": "Clove, Star Anise",
      "middle": "Cinnamon",
      "base": "Tonka Beans ----------------------------------------------------------------------"
    },
    "img": "assets/img/cinnamon-garden-ledge.jpg",
    "gallery": [
      "assets/img/cinnamon-garden-ledge.jpg",
      "assets/img/cinnamon-timber-table.jpg",
      "assets/img/cinnamon-plant-nook.jpg",
      "assets/img/cinnamon-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/cinnamon"
  },
  {
    "title": "Caramelo",
    "handle": "caramel",
    "cat": "candles",
    "price": 40.0,
    "priceMax": 40.0,
    "variants": 1,
    "desc": "Sweet scent of dulce de leche balanced with rich creamy vanilla.",
    "notes": {
      "top": "Butter, Hazelnut, Vanilla",
      "middle": "Dulce de leche",
      "base": "Vanilla cream, Condensed milk ----------------------------------------------------------------------"
    },
    "img": "assets/img/caramelo-garden-ledge.jpg",
    "gallery": [
      "assets/img/caramelo-garden-ledge.jpg",
      "assets/img/caramelo-timber-table.jpg",
      "assets/img/caramelo-plant-nook.jpg",
      "assets/img/caramelo-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/caramel"
  },
  {
    "title": "Australian Bush",
    "handle": "australian-bush",
    "cat": "candles",
    "price": 40.0,
    "priceMax": 40.0,
    "variants": 1,
    "desc": "Herbal and woody floral tones, with hints of lemon, pine and eucalyptus.",
    "notes": {
      "top": "Lemon, Pine",
      "middle": "Eucalyptus, Lemon Myrtle",
      "base": "Patchouli, Sandalwood ----------------------------------------------------------------------"
    },
    "img": "assets/img/aussie-bush-garden-ledge.jpg",
    "gallery": [
      "assets/img/aussie-bush-garden-ledge.jpg",
      "assets/img/aussie-bush-timber-table.jpg",
      "assets/img/aussie-bush-plant-nook.jpg",
      "assets/img/aussie-bush-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/australian-bush"
  },
  {
    "title": "Black Raspberry",
    "handle": "black-raspberry",
    "cat": "candles",
    "price": 40.0,
    "priceMax": 40.0,
    "variants": 1,
    "desc": "A warming yet bright berry scent of blackberry and raspberry over musk and malted vanilla.",
    "notes": {
      "top": "Strawberry, Peach Nectar, Citrus",
      "middle": "Blackberry, Ripened Raspberry, Jasmine",
      "base": "Musk, Malted Vanilla"
    },
    "img": "assets/img/black-raspberry-garden-ledge.jpg",
    "gallery": [
      "assets/img/black-raspberry-garden-ledge.jpg",
      "assets/img/black-raspberry-timber-table.jpg",
      "assets/img/black-raspberry-plant-nook.jpg",
      "assets/img/black-raspberry-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/collections/all"
  },
  {
    "title": "Paw Paw Passion",
    "handle": "paw-paw-passion",
    "cat": "candles",
    "price": 40.0,
    "priceMax": 40.0,
    "variants": 1,
    "desc": "A fresh, summery scent of passionfruit and papaya with lime and orange.",
    "notes": {
      "top": "Lime, Orange",
      "middle": "Passionfruit, Papaya",
      "base": "Vanilla, Sandalwood"
    },
    "img": "assets/img/paw-paw-passion-garden-ledge.jpg",
    "gallery": [
      "assets/img/paw-paw-passion-garden-ledge.jpg",
      "assets/img/paw-paw-passion-timber-table.jpg",
      "assets/img/paw-paw-passion-plant-nook.jpg",
      "assets/img/paw-paw-passion-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/collections/all"
  },
  {
    "title": "Sandalwood",
    "handle": "sandalwood",
    "cat": "candles",
    "price": 40.0,
    "priceMax": 40.0,
    "variants": 1,
    "desc": "A creamy, woody, soft scent of sandalwood with amber and dark musk.",
    "notes": {
      "top": "Coriander",
      "middle": "Amyris, Sandalwood",
      "base": "Amber, Dark Musk, Sandalwood"
    },
    "img": "assets/img/sandalwood-garden-ledge.jpg",
    "gallery": [
      "assets/img/sandalwood-garden-ledge.jpg",
      "assets/img/sandalwood-timber-table.jpg",
      "assets/img/sandalwood-plant-nook.jpg",
      "assets/img/sandalwood-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/collections/all"
  },
  {
    "title": "Lychee & Guava",
    "handle": "lychee-guava",
    "cat": "candles",
    "price": 40.0,
    "priceMax": 40.0,
    "variants": 1,
    "desc": "A sweet, summery fruit scent of lychee, guava and peach over coconut and vanilla.",
    "notes": {
      "top": "Lime Peel, Lychee",
      "middle": "Peach, Guava",
      "base": "Coconut, Vanilla"
    },
    "img": "assets/img/lychee-guava-garden-ledge.jpg",
    "gallery": [
      "assets/img/lychee-guava-garden-ledge.jpg",
      "assets/img/lychee-guava-timber-table.jpg",
      "assets/img/lychee-guava-plant-nook.jpg",
      "assets/img/lychee-guava-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/collections/all"
  },
  {
    "title": "Vanilla Chai",
    "handle": "vanilla-chai",
    "cat": "candles",
    "price": 40.0,
    "priceMax": 40.0,
    "variants": 1,
    "desc": "A warm, creamy, sweet and spiced cosy scent of chai tea leaves, clove and cinnamon over vanilla bean and caramel.",
    "notes": {
      "top": "Bitter Orange, Coconut Cream, Spun Sugar",
      "middle": "Chai Tea Leaves, Clove, Cinnamon",
      "base": "Creamy Vanilla Bean, Caramel, Tonka"
    },
    "img": "assets/img/vanilla-chai-garden-ledge.jpg",
    "gallery": [
      "assets/img/vanilla-chai-garden-ledge.jpg",
      "assets/img/vanilla-chai-timber-table.jpg",
      "assets/img/vanilla-chai-plant-nook.jpg",
      "assets/img/vanilla-chai-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/collections/all"
  },
  {
    "title": "Vanilla Tobacco",
    "handle": "vanilla-tobacco",
    "cat": "candles",
    "price": 40.0,
    "priceMax": 40.0,
    "variants": 1,
    "desc": "An oriental spice scent of tobacco, clove and cinnamon with anise, grapefruit and cedar.",
    "notes": {
      "top": "Anise, Grapefruit",
      "middle": "Tobacco, Clove, Cinnamon",
      "base": "Musk, Cedar, Sandalwood"
    },
    "img": "assets/img/vanilla-tobacco-garden-ledge.jpg",
    "gallery": [
      "assets/img/vanilla-tobacco-garden-ledge.jpg",
      "assets/img/vanilla-tobacco-timber-table.jpg",
      "assets/img/vanilla-tobacco-plant-nook.jpg",
      "assets/img/vanilla-tobacco-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/collections/all"
  },
  {
    "title": "Summer Watermelon",
    "handle": "summer-watermelon",
    "cat": "candles",
    "price": 40.0,
    "priceMax": 40.0,
    "variants": 1,
    "desc": "A sweet, fruity, summery scent of apple, cucumber, raspberry and strawberry.",
    "notes": {
      "top": "Apple, Cucumber",
      "middle": "Raspberry, Strawberry"
    },
    "img": "assets/img/summer-watermelon-garden-ledge.jpg",
    "gallery": [
      "assets/img/summer-watermelon-garden-ledge.jpg",
      "assets/img/summer-watermelon-timber-table.jpg",
      "assets/img/summer-watermelon-plant-nook.jpg",
      "assets/img/summer-watermelon-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/collections/all"
  },
  {
    "title": "Warm Amber",
    "handle": "warm-amber",
    "cat": "candles",
    "price": 40.0,
    "priceMax": 40.0,
    "variants": 1,
    "desc": "An alluring woody fragrance with a bold musk, leather, sandalwood and patchouli.",
    "notes": {
      "top": "Jasmine, Ozone",
      "middle": "Tonka Bean, Leather, Sandalwood, Patchouli",
      "base": "Light Musk, Amber, Dark Musk, Powder"
    },
    "img": "assets/img/warm-amber-garden-ledge.jpg",
    "gallery": [
      "assets/img/warm-amber-garden-ledge.jpg",
      "assets/img/warm-amber-timber-table.jpg",
      "assets/img/warm-amber-plant-nook.jpg",
      "assets/img/warm-amber-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/collections/all"
  },
  {
    "title": "Lavender Ylang Ylang",
    "handle": "lavender-ylang-ylang",
    "cat": "candles",
    "price": 40.0,
    "priceMax": 40.0,
    "variants": 1,
    "desc": "A floral scent of lavender and ylang ylang.",
    "notes": {},
    "img": "assets/img/lavender-ylang-ylang-garden-ledge.jpg",
    "gallery": [
      "assets/img/lavender-ylang-ylang-garden-ledge.jpg",
      "assets/img/lavender-ylang-ylang-timber-table.jpg",
      "assets/img/lavender-ylang-ylang-plant-nook.jpg",
      "assets/img/lavender-ylang-ylang-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/collections/all"
  },
  {
    "title": "Wick Trimmer",
    "handle": "wick-trimmer",
    "cat": "candles",
    "price": 20.0,
    "priceMax": 20.0,
    "variants": 1,
    "desc": "Our metal wick trimmer includes a beveled inside edge allowing for a clean easy cut before relighting.",
    "notes": {},
    "img": "assets/img/wick-trimmer-garden-ledge.jpg",
    "gallery": [
      "assets/img/wick-trimmer-garden-ledge.jpg",
      "assets/img/wick-trimmer-timber-table.jpg",
      "assets/img/wick-trimmer-plant-nook.jpg",
      "assets/img/wick-trimmer-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/wick-trimmer"
  },
  {
    "title": "3 Pack Palo Santo Soap Pack",
    "handle": "3-pack-palo-santo-soap-pack",
    "cat": "bath-body",
    "price": 30.0,
    "priceMax": 30.0,
    "variants": 1,
    "desc": "Our natural handmade aromatherapy soup gently cleanse the skin while its soothing woody aroma is believed to help clear negative energy, promote relaxation, and create a sense of emotional balance and wellbeing.",
    "notes": {},
    "img": "assets/img/soap-garden-ledge.jpg",
    "gallery": [
      "assets/img/soap-garden-ledge.jpg",
      "assets/img/soap-timber-table.jpg",
      "assets/img/soap-plant-nook.jpg",
      "assets/img/soap-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/3-pack-palo-santo-soap-pack"
  },
  {
    "title": "3 Pack Goats Milk Soap With Lemongrass & Orange",
    "handle": "goats-milk-soap-with-lemongrass-orange",
    "cat": "bath-body",
    "price": 30.0,
    "priceMax": 30.0,
    "variants": 1,
    "desc": "Ingredience Olive Oil, Goats Milk, Coconut Butter, Shea Butter, Coconut Milk, Almond Milk, Avocado Oil, Castor Oil, Turmeric, Green Clay, Ginger, Essential Oils",
    "notes": {},
    "img": "assets/img/goats-milk-garden-ledge.jpg",
    "gallery": [
      "assets/img/goats-milk-garden-ledge.jpg",
      "assets/img/goats-milk-timber-table.jpg",
      "assets/img/goats-milk-plant-nook.jpg",
      "assets/img/goats-milk-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/goats-milk-soap-with-lemongrass-orange"
  },
  {
    "title": "3 Pack Coconut Milk Soap With Lavender & Orange",
    "handle": "coconut-milk-soap-with-lavender-orange",
    "cat": "bath-body",
    "price": 30.0,
    "priceMax": 30.0,
    "variants": 1,
    "desc": "Ingredience Olive Oil, Coconut Milk, Coconut Butter, Shea Butter, Almond Oil, Avocado Oil, Turmeric, Red Clay, Ginger, Essential Oils(Orange, Lemon, Lavender)",
    "notes": {},
    "img": "assets/img/coconut-lavender-garden-ledge.jpg",
    "gallery": [
      "assets/img/coconut-lavender-garden-ledge.jpg",
      "assets/img/coconut-lavender-timber-table.jpg",
      "assets/img/coconut-lavender-plant-nook.jpg",
      "assets/img/coconut-lavender-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/coconut-milk-soap-with-lavender-orange"
  },
  {
    "title": "3 Pack Coconut Milk Soap With Charcoal, Tea Tree & Turmeric",
    "handle": "coconut-milk-soap-with-charcoal-tea-tree-turmeric",
    "cat": "bath-body",
    "price": 30.0,
    "priceMax": 30.0,
    "variants": 1,
    "desc": "Ingredience Olive Oil, Coconut Milk, Coconut Oil, Castor Oil, Coconut Butter, Turmeric, Zeolite Clay, Activated Charcoal, Cinnamon, Essential Oils (Tea Tree, La",
    "notes": {},
    "img": "assets/img/coconut-charcoal-garden-ledge.jpg",
    "gallery": [
      "assets/img/coconut-charcoal-garden-ledge.jpg",
      "assets/img/coconut-charcoal-timber-table.jpg",
      "assets/img/coconut-charcoal-plant-nook.jpg",
      "assets/img/coconut-charcoal-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/coconut-milk-soap-with-charcoal-tea-tree-turmeric"
  },
  {
    "title": "3 Pack Exfoliating Coconut Milk Soap With Black Seed, Hemp & Peppermint",
    "handle": "coconut-milk-soap-with-black-seed-hemp-peppermint",
    "cat": "bath-body",
    "price": 30.0,
    "priceMax": 30.0,
    "variants": 1,
    "desc": "Ingredience Olive Oil, Coconut Milk, Coca Butter, Shea Butter, Hemp seed Oil, Castor Oil, Black Seed, Hemp Seed, Green Clay, Essential Oils (Peppermint, Lemon,",
    "notes": {},
    "img": "assets/img/coconut-blackseed-garden-ledge.jpg",
    "gallery": [
      "assets/img/coconut-blackseed-garden-ledge.jpg",
      "assets/img/coconut-blackseed-timber-table.jpg",
      "assets/img/coconut-blackseed-plant-nook.jpg",
      "assets/img/coconut-blackseed-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/coconut-milk-soap-with-black-seed-hemp-peppermint"
  },
  {
    "title": "3 Pack Aloe Vera, Orange & Calendula Coconut Milk Soap",
    "handle": "coconut-milk-soap-with-aloe-vera-lemon",
    "cat": "bath-body",
    "price": 30.0,
    "priceMax": 30.0,
    "variants": 1,
    "desc": "A pack of three Aloe Vera, Orange & Calendula coconut milk soaps. Ingredients: Aloe Vera, Coconut Milk, Coconut Oil, Cocoa Butter, Castor Oil, Orange, Calendula.",
    "notes": {},
    "img": "assets/img/calendula-soap-garden-ledge.jpg",
    "gallery": [
      "assets/img/calendula-soap-garden-ledge.jpg",
      "assets/img/calendula-soap-timber-table.jpg",
      "assets/img/calendula-soap-plant-nook.jpg",
      "assets/img/calendula-soap-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/coconut-milk-soap-with-aloe-vera-lemon"
  },
  {
    "title": "3 Pack Rose Geranium & Bergamot Coconut Milk Soap",
    "handle": "coconut-milk-soap-with-rose-geranium-bergamot",
    "cat": "bath-body",
    "price": 30.0,
    "priceMax": 30.0,
    "variants": 1,
    "desc": "A pack of three Rose Geranium & Bergamot coconut milk soaps, topped with dried rose petals and rosebuds.",
    "notes": {},
    "img": "assets/img/rose-geranium-soap-garden-ledge.jpg",
    "gallery": [
      "assets/img/rose-geranium-soap-garden-ledge.jpg",
      "assets/img/rose-geranium-soap-timber-table.jpg",
      "assets/img/rose-geranium-soap-plant-nook.jpg",
      "assets/img/rose-geranium-soap-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/coconut-milk-soap-with-rose-geranium-bergamot"
  },
  {
    "title": "3 Piece Assorted Soap Set With Dish",
    "handle": "3-piece-assorted-soap-set-with-dish",
    "cat": "bath-body",
    "price": 35.0,
    "priceMax": 35.0,
    "variants": 1,
    "desc": "Complementary bamboo soap dish, with t hree assorted Aromatherapy soaps from the following list: Lavender & Orange Coconut milk soap Activated Charcoal & Tea-tr",
    "notes": {},
    "img": "assets/img/assorted-soap-garden-ledge.jpg",
    "gallery": [
      "assets/img/assorted-soap-garden-ledge.jpg",
      "assets/img/assorted-soap-timber-table.jpg",
      "assets/img/assorted-soap-plant-nook.jpg",
      "assets/img/assorted-soap-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/3-piece-assorted-soap-set-with-dish"
  },
  {
    "title": "Aromatherapy Essential Oil Roller 3 Pack",
    "handle": "essential-oil-roller-3-pack",
    "cat": "aromatherapy",
    "price": 50.0,
    "priceMax": 50.0,
    "variants": 1,
    "desc": "3 Pack of Aromatherapy rollers — Purify, Soothe and Harmony — to accommodate your every mood.",
    "notes": {},
    "sub": "Purify, Soothe & Harmony",
    "img": "assets/img/roller-3pack-garden-ledge.jpg",
    "gallery": [
      "assets/img/roller-3pack-garden-ledge.jpg",
      "assets/img/roller-3pack-timber-table.jpg",
      "assets/img/roller-3pack-plant-nook.jpg",
      "assets/img/roller-3pack-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/essential-oil-roller-3-pack"
  },
  {
    "title": "Soothe Essential Oil Roller",
    "handle": "soothe-essential-oil-roller",
    "cat": "aromatherapy",
    "price": 20.0,
    "priceMax": 20.0,
    "variants": 1,
    "desc": "Designed to calm and soothe your senses.",
    "notes": {},
    "img": "assets/img/soothe-roller-garden-ledge.jpg",
    "gallery": [
      "assets/img/soothe-roller-garden-ledge.jpg",
      "assets/img/soothe-roller-timber-table.jpg",
      "assets/img/soothe-roller-plant-nook.jpg",
      "assets/img/soothe-roller-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/soothe-essential-oil-roller"
  },
  {
    "title": "Purify Essential Oil Roller",
    "handle": "purify-essential-oil-roller",
    "cat": "aromatherapy",
    "price": 20.0,
    "priceMax": 20.0,
    "variants": 1,
    "desc": "Designed to refresh and purify your senses.",
    "notes": {},
    "img": "assets/img/purify-roller-garden-ledge.jpg",
    "gallery": [
      "assets/img/purify-roller-garden-ledge.jpg",
      "assets/img/purify-roller-timber-table.jpg",
      "assets/img/purify-roller-plant-nook.jpg",
      "assets/img/purify-roller-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/purify-essential-oil-roller"
  },
  {
    "title": "Harmony Essential Oil Roller",
    "handle": "harmony-essential-oil-roller",
    "cat": "aromatherapy",
    "price": 20.0,
    "priceMax": 20.0,
    "variants": 1,
    "desc": "Designed to bring balance and harmony to your senses.",
    "notes": {},
    "img": "assets/img/harmony-roller-garden-ledge.jpg",
    "gallery": [
      "assets/img/harmony-roller-garden-ledge.jpg",
      "assets/img/harmony-roller-timber-table.jpg",
      "assets/img/harmony-roller-plant-nook.jpg",
      "assets/img/harmony-roller-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/harmony-essential-oil-roller"
  },
  {
    "title": "Pure Essential Oil Blends",
    "handle": "pure-essential-oil-blend",
    "cat": "aromatherapy",
    "price": 25.0,
    "priceMax": 25.0,
    "variants": 3,
    "desc": "Available in three blends: Purify, Soothe and Harmony. Each is formulated for a different mood.",
    "notes": {},
    "img": "assets/img/oil-blend-garden-ledge.jpg",
    "gallery": [
      "assets/img/oil-blend-garden-ledge.jpg",
      "assets/img/oil-blend-timber-table.jpg",
      "assets/img/oil-blend-plant-nook.jpg",
      "assets/img/oil-blend-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/pure-essential-oil-blend",
    "variantGalleries": {
      "purify": [
        "assets/img/oil-blend-garden-ledge.jpg",
        "assets/img/oil-blend-timber-table.jpg",
        "assets/img/oil-blend-plant-nook.jpg",
        "assets/img/oil-blend-ivory-studio.jpg"
      ],
      "soothe": [
        "assets/img/soothe-oil-blend-garden-ledge.jpg",
        "assets/img/soothe-oil-blend-timber-table.jpg",
        "assets/img/soothe-oil-blend-plant-nook.jpg",
        "assets/img/soothe-oil-blend-ivory-studio.jpg"
      ],
      "harmony": [
        "assets/img/harmony-oil-blend-garden-ledge.jpg",
        "assets/img/harmony-oil-blend-timber-table.jpg",
        "assets/img/harmony-oil-blend-plant-nook.jpg",
        "assets/img/harmony-oil-blend-ivory-studio.jpg"
      ]
    },
    "sub": "Purify, Soothe, Harmony"
  },
  {
    "title": "Palo Santo Cleansing Room Spray",
    "handle": "palo-santo-cleansing-room-spray",
    "cat": "aromatherapy",
    "price": 35.0,
    "priceMax": 35.0,
    "variants": 1,
    "desc": "A soulful blend of Palo Santo, Rose Geranium, Lavender and Lemongrass essential oils, created to refresh your space and invite a sense of calm, clarity and positive energy. Mist lightly around your room whenever you wish to cleanse, reset and create a peaceful, harmonious atmosphere.",
    "notes": {},
    "img": "assets/img/spray-garden-ledge.jpg",
    "gallery": [
      "assets/img/spray-garden-ledge.jpg",
      "assets/img/spray-timber-table.jpg",
      "assets/img/spray-plant-nook.jpg",
      "assets/img/spray-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/palo-santo-cleansing-room-spray",
    "short": "If smoke is not your vibe..."
  },
  {
    "title": "Cleansing Wand",
    "handle": "cleansing-wand",
    "cat": "aromatherapy",
    "price": 20.0,
    "priceMax": 20.0,
    "variants": 1,
    "desc": "A beautiful pack of White Sage and Palo Santo, lovingly adorned with dried flowers. Use it to cleanse your home, space, or yourself, clearing stagnant energy and inviting a sense of peace, balance and positive energy into your surroundings.",
    "notes": {},
    "facts": [
      [
        "how to use",
        "Light the two, separately or together, then gently wave the flame. Move the wand slowly around your space, focusing on areas you wish to cleanse. Set an intention and welcome peace."
      ],
      [
        "safety",
        "Use in a ventilated area, away from children and pets. Never leave burning herbs unattended, and extinguish after use."
      ]
    ],
    "img": "assets/img/cleansing-wand-garden-ledge.jpg",
    "gallery": [
      "assets/img/cleansing-wand-garden-ledge.jpg",
      "assets/img/cleansing-wand-timber-table.jpg",
      "assets/img/cleansing-wand-plant-nook.jpg",
      "assets/img/cleansing-wand-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/collections/all"
  },
  {
    "title": "Tallow Balm",
    "handle": "tallow-balm",
    "cat": "aromatherapy",
    "price": 25.0,
    "priceMax": 40.0,
    "variants": 2,
    "desc": "Our Tallow balm is deeply hydrating, made with 100% grass-fed beef tallow, created to repair and nourish dry and sensitive skin, rich in vitamin A, D, E, & K. Sizes: Small 45g, Large 85g. Assists with softening skin, increasing skin elasticity and antioxidant protection. Ingredients: 100% grass-fed beef tallow, castor oil, jojoba oil, vitamin E, and essential oils (lavender, frankincense and tea tree).",
    "notes": {},
    "img": "assets/img/tallow-balm-garden-ledge.jpg",
    "gallery": [
      "assets/img/tallow-balm-garden-ledge.jpg",
      "assets/img/tallow-balm-timber-table.jpg",
      "assets/img/tallow-balm-plant-nook.jpg",
      "assets/img/tallow-balm-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/tallow-balm"
  },
  {
    "title": "Eye Serum",
    "handle": "eye-serum",
    "cat": "aromatherapy",
    "price": 25.0,
    "priceMax": 25.0,
    "variants": 1,
    "desc": "Crafted to rejuvenate and restore the delicate under-eye, this serum is gentle yet powerful.",
    "notes": {},
    "img": "assets/img/eye-serum-garden-ledge.jpg",
    "gallery": [
      "assets/img/eye-serum-garden-ledge.jpg",
      "assets/img/eye-serum-timber-table.jpg",
      "assets/img/eye-serum-plant-nook.jpg",
      "assets/img/eye-serum-ivory-studio.jpg"
    ],
    "url": "https://soycandlelab.com.au/products/eye-serum"
  }
];


/* ---- Shopify adapter: the catalogue above is design/copy enrichment; the live Shopify products decide what is shown, the price and the links. ---- */
(function(){
  var B = window.SCL_ASSET_BASE || '', L = window.SCL_LIVE || [];
  var A = function(p){ return (p && !/^(https?:)?\/\//.test(p)) ? B + p.split('/').pop() + '?v=20261008i' : p; };
  var HIDE = ['nag-champa', 'invigorate-essential-oil-roller'];
  var catOf = function(t){
    t = (t || '').toLowerCase();
    if (/candle|trimmer/.test(t)) return 'candles';
    if (/soap/.test(t)) return 'bath-body';
    return 'aromatherapy';
  };
  var live = {}; L.forEach(function(x){ live[x.handle] = x; });
  var out = [];
  PRODUCTS.forEach(function(p){
    var l = live[p.handle]; if (!l || HIDE.indexOf(p.handle) > -1) return;
    p.img = A(p.img); p.gallery = (p.gallery || []).map(A);
    if (p.variantGalleries) Object.keys(p.variantGalleries).forEach(function(k){ p.variantGalleries[k] = p.variantGalleries[k].map(A); });
    p.price = l.price; p.priceMax = l.priceMax; p.variants = l.variants;
    if(!p.desc) p.desc = l.desc; p.available = l.available; p.vid = l.vid; p.url = '/products/' + p.handle;
    out.push(p);
  });
  L.forEach(function(l){
    if (HIDE.indexOf(l.handle) > -1 || PRODUCTS.some(function(p){ return p.handle === l.handle; })) return;
    out.push({ title:l.title, handle:l.handle, cat:catOf(l.type), price:l.price, priceMax:l.priceMax, variants:l.variants,
      desc:l.desc, notes:{}, img:l.img, gallery:[l.img], url:'/products/' + l.handle, available:l.available, vid:l.vid });
  });
  PRODUCTS.length = 0;
  out.forEach(function(p){ PRODUCTS.push(p); });
})();
